import { EventEmitter } from '@angular/core';
import { ApiService } from "../api.service";
import { CommonService } from '../common.service';
var CasePracticeAuthorizationVideoComponent = (function () {
    function CasePracticeAuthorizationVideoComponent(apiService, commonService) {
        this.apiService = apiService;
        this.commonService = commonService;
        this.onGoToNextStep = new EventEmitter();
        this.showVideo = true;
        this.assetsRoute = "../../assets";
    }
    CasePracticeAuthorizationVideoComponent.prototype.ngOnInit = function () {
        this.assetsRoute = this.commonService.setAssetsRoute(this.assetsRoute);
        var _this = this;
        _this.showVideo = true;
        window['s2j_onPlayOver'] = function () {
            _this.showVideo = false;
            setTimeout(function () {
                _this.onGoToNextStep.emit(2);
                _this.commonService.setOnceIno(_this.commonService.getOnceValue(_this.exerciseMetaId, 701)).subscribe();
            }, 300);
        };
    };
    CasePracticeAuthorizationVideoComponent.prototype.ngAfterViewInit = function () {
        var player = polyvPlayer({
            wrap: '#video-auth',
            width: '100%',
            height: this.isPC ? '100vh' : window.screen.width / 9 * 16,
            vid: '352e2664d87bd3406306f195c9115e98_3',
            // autoplay: true,
            // skinLocation: 0,
            ban_history_time: 'on',
            // hideSwitchPlayer: true,
            hideRepeat: true,
            forceH5: true,
            flashvars: { 'autoplay': true }
            // audioMode: false
        });
        if (!this.isPC) {
            player.toggleFullscreen();
        }
    };
    return CasePracticeAuthorizationVideoComponent;
}());
export { CasePracticeAuthorizationVideoComponent };



// WEBPACK FOOTER //
// ./src/app/case-practice-authorization-video/case-practice-authorization-video.component.ts.pre-build-optimizer.js